interface PageHeroProps {
  badge?: string;
  title: string;
  titleEm?: string;
  subtitle?: string;
  image: string;
}

export default function PageHero({ badge, title, titleEm, subtitle, image }: PageHeroProps) {
  return (
    <section className="relative h-[380px] md:h-[500px] overflow-hidden">
      <img
        src={image}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      {/* Warm dark overlays — same feel as hero */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#100700]/70 via-[#1e0c00]/35 to-[#0a0400]/15" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0f0600]/55 via-[#2a1000]/10 to-transparent" />
      {/* Top gradient so navbar text stays readable */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-transparent" />

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 pt-16 md:pt-20 pb-4">
        {badge && (
          <span className="text-[#67CBFF] text-xs tracking-widest uppercase font-semibold mb-4">
            {badge}
          </span>
        )}
        <h1 className="font-display text-4xl md:text-6xl font-bold text-white leading-tight">
          {title}
          {titleEm && (
            <> <span className="text-[#67CBFF]">{titleEm}</span></>
          )}
        </h1>
        {subtitle && (
          <p className="text-white/70 text-sm md:text-base mt-4 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}